import React from "react";
import { Col, Image, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { formatDate, formatTime } from "../../utils/dateUtils";

const AcceptedPhotographers = ({ photographerData }) => {
  return (
    <Table bordered hover>
      <thead>
        <tr>
          <th>Partner ID</th>
          <th>Partner</th>
          <th>Onboarded On</th>
          <th>Services</th>
          <th>Location</th>
          <th>Fulfilled Orders</th>
        </tr>
      </thead>
      <tbody>
        {photographerData.map((photographer, index) => (
          <tr key={index}>
            <td>{photographer.personalDetails.customId}</td>
            <td>
              <Link
                to={`/admin/photographers/${photographer.personalDetails.customId}`}
                state={{ photographerData: photographer }}
                style={{
                  cursor: "pointer",
                  color: "inherit",
                  textDecoration: "inherit",
                }}
              >
                <Row>
                  <Col xs={4} md={2} style={{ marginRight: "10px" }}>
                    <Image
                      src={photographer.personalDetails.profileImage}
                      roundedCircle
                      width={50}
                      height={50}
                      style={{ objectFit: "cover" }}
                    />
                  </Col>
                  <Col>
                    <div>{photographer.personalDetails.name}</div>
                    <div>{photographer.personalDetails.email}</div>
                    <div>{photographer.personalDetails.phone}</div>
                  </Col>
                </Row>
              </Link>
            </td>
            <td>
              <div>{formatDate(photographer.personalDetails.approvedOn)}</div>
              <div>{formatTime(photographer.personalDetails.approvedOn)}</div>
            </td>
            <td>
              {`P - ${photographer.personalDetails.photographyServices.primary}`}
              <br />
              {`S - ${photographer.personalDetails.photographyServices.secondary.join(
                ", "
              )}`}
            </td>
            <td>{photographer.personalDetails.address}</td>
            <td>{photographer.personalDetails.fullFilledOrders}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default AcceptedPhotographers;
